"use strict";

const moment = require("moment");
const DateUtil = require("../libs/DateUtil");

class CoursePrivateUtil {


  /**
   * Vygeneruje casole sloty pro konkretni 1 den podle vychozich casu a pozadovane delce
   * 
   * @param {*} date datum konkretniho dne
   * @param {*} startTimes pole stringu s pocatecnimy casy ve formatu ["HH:MM", "HH:MM"]
   * @param {*} defaultLessonLength delka vygenerovaneho casoveho bloku
   */
  static getEventsByStartTimes(date, startTimes, defaultLessonLength) {
    let events = [];
    console.log();
    for (let i = 0; i < startTimes.length; i++) {
      let st = startTimes[i];
      let startTime = moment(date.format("YYYY-MM-DD") + "T" + st + ":00");
      let endTime = moment(startTime);
      endTime.add(defaultLessonLength, "hours");
      let length = moment(endTime).diff(moment(startTime), "hour");
      let e = {
        name: startTime.format(),
        start: startTime.toDate(),
        end: endTime.toDate(),
        timeLength: length,
        hash: startTime.format() + "_" + endTime.format(),
        timed: true,
        engaged: false
      };
      //console.log(e);
      events.push(e);
    }
    return events;
  }

  /**
     * Vytvoreni candidate slotu
     *
     * @param product
     * @param schoolBookingOffset
     * @param startDate
     * @param endDate
     *
     */
    static getEventsByProduct(product, schoolBookingOffset, startDate, endDate) {
      let minimalStartDate = null;
      let todayPlusOffset = moment().add(
        schoolBookingOffset,
        "minutes"
      );
      if (
        product.enabledFrom != null &&
        moment(product.enabledFrom).format("X") <
          todayPlusOffset.format("X")
      ) {
        console.log("product.enabledFrom");
        console.log(product.enabledFrom);
        console.log(moment(product.enabledFrom).format());
        minimalStartDate = moment(product.enabledFrom);
      } else {
        console.log("ELSE");
        console.log(todayPlusOffset.format());
        minimalStartDate = todayPlusOffset;
      }

      // console.log("todayPlusOffset.format():");
      // console.log(todayPlusOffset.format());
      // console.log(todayPlusOffset.format("X"));

      // console.log("minimalStartDate.format():");
      // console.log(minimalStartDate.format());
      // console.log(minimalStartDate.format("X"));

      //let lastStart = moment(startDate);
      console.log("endDate:: ");
      console.log(endDate);

      console.log("startDate:: ");
      console.log(startDate);

      let lastEnd = moment(endDate);
      let i = moment(startDate);
      let events = [];

      // 1. iteruj mezi start a end
      while (i.format("X") <= lastEnd.format("X")) {
        // 2. over, jestli je v dany den mozne vytvaret vyukove bloky
        // console.log("Iterace pres kalendar");
        // console.log(i.format());
        // console.log(i.format("X"));
        if (i.format("X") < minimalStartDate.format("X")) {
          // console.log("-- preskocit");
        }
        if (
          i.format("X") >= minimalStartDate.format("X") &&
          ((i.day() === 0 && product.timePreferencesEnabledMonday) ||
            (i.day() === 1 && product.timePreferencesEnabledTuesday) ||
            (i.day() === 2 && product.timePreferencesEnabledWednesday) ||
            (i.day() === 3 && product.timePreferencesEnabledThursday) ||
            (i.day() === 4 && product.timePreferencesEnabledFriday) ||
            (i.day() === 5 && product.timePreferencesEnabledSaturday) ||
            (i.day() === 6 && product.timePreferencesEnabledSunday))
        ) {
          // 3. pro kazdy definovany zacatek vytvor novy event
          // 4. prirad eventu hashId
          events = events.concat(
            CoursePrivateUtil.getEventsByStartTimes(
              i,
              product.timePreferencesStartTimes,
              product.defaultLessonLength
            )
          );
        }
        i.add(1, "days");
      }
      return events;
    }

    static transformEventsToCandidateSlots(calendarEvents) {
      let candidateSlots = [];
      for(let i=0; i < calendarEvents.length; i++) {
        const cs = {
          timeFrom: DateUtil.dateToAWSDateTime(calendarEvents[i].start),
          timeTo: DateUtil.dateToAWSDateTime(calendarEvents[i].end)
        }
        candidateSlots.push(cs);
      }
      return candidateSlots;
    }

    static transformFreeSlotsToEvents(freeSlots) {
      let events = [];

      for(let i=0; i < freeSlots.length; i++) {
        const fs = freeSlots[i];
        const e = {
          start: moment(fs.timeFrom).toDate(), //  zde oriznou TZ
          end: moment(fs.timeTo).toDate(), //  zde oriznou TZ
          timeLength: 1,
          sganttWorkDayMssId: fs.sganttWorkDayMssId,
          subjectMssId: fs.subjectMssId,
          hash: fs.sganttWorkDayMssId + "_" + moment(fs.timeFrom).toDate() + "_" + moment(fs.timeTo).toDate(),
          name: fs.subjectMssId,
          engaged: false,
          timed: true
        }
        events.push(e);
      }

      return events;
    }

    static extractVariantsFromFreeSlots(freeSlots) {
      let subjectMssIds = [];
      for(let i=0; i < freeSlots.length; i++) {
        const fs = freeSlots[i];
        subjectMssIds.push(fs.subjectMssId);
      }
      
      return subjectMssIds.filter(CoursePrivateUtil.onlyUnique);
    }

    static onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }

}

module.exports = CoursePrivateUtil;